import { RouterRootView } from '@opengov/compose-app-router/components';

import { selectStoriesPageProps, StoriesPage } from './stories';

export const rootView = RouterRootView(StoriesPage, selectStoriesPageProps);
